export default __webpack_public_path__ + "static/media/Active.5799fbab.svg";